import { render, staticRenderFns } from "./academic_word_management.vue?vue&type=template&id=a56bdad0&"
import script from "./academic_word_management.vue?vue&type=script&lang=js&"
export * from "./academic_word_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports